module.exports = __webpack_public_path__ + "static/media/logo.a826840f.png";